import React from 'react'
import logo from "../../assets/Images/logo.png";
import { Link, NavLink } from "react-router-dom";

import { FaPhone } from "react-icons/fa6";
import { MdOutlineMail } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";

function FooterMenu() {
    return (
        <div className='footer-menu'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-4 gap-4 d-flex flex-column">
                        <Link to = "/" className='logo-img'><img src={logo} alt="logo" /></Link>
                        <p>Nexelis provides cutting-edge digital solutions to help startups, small, medium, and large companies transform their operations.</p>
                        <span className="d-flex gap-4 mt-4">
                            <a href="https://web.facebook.com/NexelisTechnologies" target="blank"><FaFacebook className="icon2" /></a>
                            <a href="https://www.instagram.com/nexelistechnologies/" target="blank"><FaInstagram className="icon2" /></a>
                            <a href="https://x.com/NexelisTech" target='blank'><FaXTwitter className="icon2" /></a>
                            <a href="https://www.linkedin.com/company/nexelis-technologies/" target="blank"><FaLinkedin className="icon2" /></a>
                        </span>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-6 col-6">
                        <h4>Quick Links</h4>
                        <ul className="list-inline list-unstyled d-flex flex-column gap-4">
                            <li><Link to = "/">Home</Link></li>
                            <li><Link to = "/About">About</Link></li>
                            <li><Link to = "/Project">Portfolio</Link></li>
                            <li><Link to = "/blog">Blogs</Link></li>
                        </ul>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-6 col-6 d-flex align-items-end">
                        <ul className="list-unstyled d-flex flex-column gap-4">
                            <li><Link to = "/faq">FAQ</Link></li>
                            <li><Link to = "/Contact">Contact</Link></li>
                            <li><Link to = "/team">Team</Link></li>
                            <li><a href="#">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div className="col-lg-4 col-md-4 d-flex flex-column align-items-md-start align-items-sm-center align-items-center">
                        <h4>Get Connected</h4>
                        <ul className="list-unstyled d-flex flex-column gap-4">
                            <li>
                                <a href="#"><FaPhone className="icon2" /></a>
                                <a href="#">abdullahkhalid7892@gmail.com</a>
                            </li>
                            <li>
                                <a href="#"><MdOutlineMail className="icon2" /></a>
                                <a href="#">+92 3069126229</a>
                            </li>
                            <li>
                                <a href="#"><IoMdTime className="icon2" /></a>
                                <a href="#">Office Hours: 8AM - 11PM Sunday - Weekend Day</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterMenu
